import { validatePhoneNumber } from '@repo/design-system-kit';
import { z } from 'zod';

export const requiredString = (
  errorMessage = 'company-creation-kit.creation-hub.validations.errors.blank'
) => z.string().min(1, errorMessage);

export const email = z
  .string()
  .min(1, 'company-creation-kit.creation-hub.validations.errors.blank')
  .email('company-creation-kit.creation-hub.validations.errors.email');

export const phoneNumber = z
  .string()
  .min(1, 'company-creation-kit.creation-hub.validations.errors.blank')
  .refine(value => validatePhoneNumber(value), {
    message: 'company-creation-kit.creation-hub.validations.errors.invalid-phone-number',
  });

export const requiredCheckbox = (
  errorMessage = 'company-creation-kit.creation-hub.validations.errors.checkbox-not-ticked'
) =>
  z.boolean().refine(value => value, {
    message: errorMessage,
  });
